<template>
  <o-view>
    <o-nav-bar title="VAB Assistance" :has-back-button="true" />
    <o-block-list title="Startdatum">
      <o-section>
        <o-text-input icon="date" value="2018-10-26" type="date" />
      </o-section>
    </o-block-list>
    <o-block-list title="Opties">
      <o-section>
        <o-tab-switch
          name="first"
          :items="['Eerste voertuig', 'Extra voertuig']"
        />
      </o-section>
      <o-section>
        <o-text-input placeholder="Nummerplaat" icon="car" />
      </o-section>
      <o-section>
        <o-checkbox name="pechbijstand">
          Pechbijstand voor een bijkomend voertuig
        </o-checkbox>
        <o-checkbox name="vervangwagen">Vervangwagen</o-checkbox>
      </o-section>
    </o-block-list>
    <o-button
      to="/sales/assistance/vab/ticket"
      label="Prijs berekenen"
      :is-primary="true"
      :is-floating="true"
    />
  </o-view>
</template>

<script>
export default {
  name: 'NMBS1'
}
</script>
